import clsx from 'clsx'
import { Button, Col, Search, Select } from 'components/common'
import {
  CustomerConditionType,
  CustomerQueryInput,
  CustomerQueryType,
} from 'lib/graphql/storeadmin'
import { commonSelectedOption, personalSelectedOption } from 'lib/constants'
import { useState } from 'react'

interface customerSelectOptions {
  phone?: string
  address__city?: string
  email: string
  corporation_name?: string
  last_name?: string
  first_name?: string
}

export interface CustomerSearchProps {
  onSearchBack: (searchField: string, input: CustomerQueryInput) => void
  selectOptions: customerSelectOptions
  searchClear: () => void
  placeholder?: string
  defaultValue?: keyof typeof personalSelectedOption
}

export const CustomerSearch = ({
  onSearchBack,
  selectOptions,
  searchClear,
  placeholder,
  defaultValue,
}: CustomerSearchProps): JSX.Element => {
  const [searchField, setSearchField] = useState('')
  const [searchOption, setSearchOption] = useState('')
  const handleSelectChange = (value) => {
    setSearchOption(value)
  }
  const onSearch = () => {
    const searchQueryInput = {
      condition: CustomerConditionType.Contains,
      field:
        searchOption !== ''
          ? searchOption
          : defaultValue || Object.keys(commonSelectedOption)[0],
      type: CustomerQueryType.And,
      value: searchField?.replace(/\s/g, ''),
    }
    onSearchBack(searchField, searchQueryInput)
  }
  const options = Object.entries(selectOptions).map(([key, value]) => (
    <Select.Option key={key} value={key}>
      {value}
    </Select.Option>
  ))

  return (
    <>
      <Col className={clsx('flex', 'items-center')}>
        <Search
          autoComplete="off"
          placeholder={placeholder || '顧客を絞り込む'}
          value={searchField}
          onChange={(e) => setSearchField(e.target.value)}
          onSearch={onSearch}
        />
        <Col className={clsx('flex', 'flex-end', 'justify-end', 'pl-4')}>
          <Select
            style={{ width: 150 }}
            defaultValue={defaultValue || personalSelectedOption?.phone}
            onChange={handleSelectChange}
          >
            {options}
          </Select>
          <Col className={clsx('pl-4')}>
            <Button onClick={onSearch}>絞り込む</Button>
          </Col>
          <Col className={clsx('pl-4')}>
            <Button
              onClick={() => {
                if (searchField) {
                  setSearchField(null)
                  searchClear()
                }
              }}
            >
              クリア
            </Button>
          </Col>
        </Col>
      </Col>
    </>
  )
}
